// Packages
import PropTypes from 'prop-types'

// Components
import CustomerForm from 'modules/Customers/components/Form';

// Other
import useApi from 'hooks/useApi';

const CustomerEditScreen = ({  itemId, onClose, onSubmit }) => {

    const { data: item, put: updateItem, errors } = useApi('/customers/' + itemId);

	const submit = async (values) => {

        if( await updateItem(values, 'Customer updated!')) {

            onSubmit();
        }
    }

    return(
        <CustomerForm 
            errors={errors} 
            customer={item} 
            onClose={onClose} 
            onSubmit={submit} 
            type='edit' 
        />
    )
}

CustomerEditScreen.propTypes = {
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClose: PropTypes.func,
    onSubmit: PropTypes.func,
}

CustomerEditScreen.defaultProps = {
    itemId: null,
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')}
}

export default CustomerEditScreen;